import { createContext, useContext } from 'react';
import { CalendarStore } from '@uplift/store';

export const CalendarStoreContext = createContext<CalendarStore>(null);

export function useCalendarStore() {
  const calendarStore = useContext(CalendarStoreContext);

  return calendarStore;
}
